import React from 'react';
import { Button } from 'components/Button';
import { Link } from 'components/Link';
import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
type Props = {
  onClose: () => void;
  isConfirmDisable?: boolean;
  isLoading?: boolean;
  confirmText: string;
  showPricingLink?: boolean;
};
export const ModalFooter: React.FC<Props> = ({
  onClose,
  isConfirmDisable,
  isLoading,
  confirmText,
  showPricingLink = false
}) => {
  return <div className={container}>
      {showPricingLink && <Link data-testid="learn-more" className="price-link" href="https://www.clarifai.com/pricing" target="_blank">
          Learn more about pricing
        </Link>}
      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" type="submit" disabled={isConfirmDisable || isLoading} loading={isLoading}>
        {confirmText}
      </Button>
    </div>;
};
const container = "odules__User__components__Settings__Billing__AutoRecharge__ModalFooter_tsx-container-cfp3tp";

require("./ModalFooter.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ModalFooter.tsx");